module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/img04-0d339ca231525f202aa51a3fa276b398.png";